interface TEnvConfig {
    DEFAULTLOCALE: string;
    ONETRUST_SCRIPT_ID: string;
    BRANCHNAME: string;
    BACKEND_HOST: string;
    BACKEND_APIKEY: string;
    MEDIADOMAIN: string;
    AG_USERHASH: string;
}
export const getPublicEnvConfig = (): Omit<TEnvConfig, 'BACKEND_APIKEY'> => {
    return {
        DEFAULTLOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE!,
        ONETRUST_SCRIPT_ID: process.env.NEXT_PUBLIC_ONETRUST_SCRIPT_ID!,
        BRANCHNAME: process.env.NEXT_PUBLIC_BRANCH_NAME!,
        BACKEND_HOST: process.env.NEXT_PUBLIC_BACKEND_HOST!,
        MEDIADOMAIN: process.env.NEXT_PUBLIC_MEDIADOMAIN!,
        AG_USERHASH: process.env.NEXT_PUBLIC_AG_USERHASH!
    }
}